// What the team reads for a payment's status; the API keeps the English codes.
export const PURCHASE_STATUS_LABELS = {
  paid: "Plătită",
  pending: "În așteptare",
  pending_registration: "Înscriere fără plată",
  abandoned: "Abandonată",
  cancelled: "Anulată",
  failed: "Eșuată",
  refunded: "Rambursată",
  duplicate: "Duplicat",
};

export const purchaseStatusLabel = (status) => PURCHASE_STATUS_LABELS[status] || status || "—";
